export default __webpack_public_path__ + "static/jor-small-batches-f3127ff30c913c14b1e0c600160e0b12.svg";